import { render, staticRenderFns } from "./IndexVersion.vue?vue&type=template&id=1c0e2ae9&scoped=true&"
import script from "./IndexVersion.vue?vue&type=script&lang=js&"
export * from "./IndexVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e2ae9",
  null
  
)

export default component.exports